export const TRANSLATE_SEPERATE = `----------------`
export const TRANSLATE_SEPERATE_WITH_NEWLINE = `\n${TRANSLATE_SEPERATE}\n`
